{
  "app.title": "eTTS — Test Token Server",
  "nav.dashboard": "Prehľad",
  "nav.tokens": "Tokeny",
  "nav.logs": "Logy",
  "nav.transactionLogs": "Transakčné logy",
  "nav.serverStats": "Štatistiky servera",
  "nav.settings": "Nastavenia",
  "nav.docs": "Pomocník",
  "nav.signOut": "Odhlásiť sa",
  "header.settings": "Nastavenia",
  "header.notifications": "Oznámenia",
  "header.account": "Účet",
  "notifications.title": "Oznámenia",
  "notifications.empty": "Žiadne oznámenia.",
  "theme.label": "Vzhľad",
  "theme.system": "Systém",
  "theme.light": "Svetlý",
  "theme.dark": "Tmavý",
  "theme.switchToDark": "Prepnúť na tmavý motív",
  "theme.switchToLight": "Prepnúť na svetlý motív",
  "login.title": "Prihlásenie",
  "login.subtitle": "Prihláste sa do administrácie eTTS",
  "login.username": "Používateľské meno",
  "login.password": "Heslo",
  "login.submit": "Prihlásiť sa",
  "login.error": "Nesprávne meno alebo heslo.",
  "login.loggedOut": "Boli ste odhlásení.",
  "login.expired": "Vaša relácia vypršala. Prihláste sa znova.",
  "dashboard.title": "Prehľad",
  "dashboard.welcome": "Vitajte v administrácii eTTS.",
  "dashboard.tokensTotal": "Tokeny celkovo",
  "dashboard.tokensActive": "Aktívne",
  "dashboard.tokensDeleted": "Zmazané",
  "dashboard.tokensActivating": "Aktivujú sa",
  "dashboard.tokensFailed": "Chybné",
  "dashboard.authServerDistribution": "Distribúcia podľa auth servera",
  "dashboard.noData": "Žiadne dáta",
  "dashboard.systemStats": "Systémové štatistiky",
  "dashboard.systemStats.transactions": "Transakcie spolu",
  "dashboard.systemStats.activationEvents": "Aktivačné udalosti",
  "dashboard.systemStats.commLogs": "Komunikačné logy",
  "dashboard.quickActions": "Rýchle akcie",
  "dashboard.quick.viewTokens": "Všetky tokeny",
  "dashboard.quick.testActivation": "Test aktivácie",
  "dashboard.quick.apiDocs": "API dokumentácia",
  "dashboard.quick.health": "Health check",
  "tokens.title": "Tokeny",
  "tokens.subtitle": "Zoznam tokenov spravovaných týmto serverom.",
  "tokens.col.tokenId": "Token ID",
  "tokens.col.username": "Používateľ",
  "tokens.col.state": "Stav",
  "tokens.col.connector": "Konektor",
  "tokens.col.created": "Vytvorené",
  "tokens.backToList": "Späť na zoznam",
  "tokens.field.licenceId": "Licencia ID",
  "tokens.field.instanceSeq": "Inštancia",
  "tokens.field.activationGuid": "Aktivačný GUID",
  "tokens.field.activated": "Aktivované",
  "tokens.field.updated": "Aktualizované",
  "tokens.field.activationEvents": "Aktivačných udalostí",
  "tokens.field.keyStorageFormat": "Režim úložiska kľúčov",
  "tokens.keyStorageFormat.ETTS": "ETTS",
  "tokens.keyStorageFormat.ETTS.hint": "lacné odvodenie kľúča z hesla — režim pre výkonnostné testy",
  "tokens.keyStorageFormat.SECURE": "SECURE",
  "tokens.keyStorageFormat.SECURE.hint": "Argon2id — plné šifrovanie úložiska, výrazne pomalšia aktivácia",
  "tokens.keyStorageFormat.unrecorded": "nezaznamenané — token vznikol skôr, než sa režim ukladal",
  "tokens.field.expires": "Expirácia",
  "tokens.field.tags": "Tagy",
  "tokens.connectorAttributes": "Atribúty konektora",
  "logs.title": "Logy",
  "logs.subtitle": "Komunikačné logy auth serverov a aplikačný log (auto-refresh 10 s).",
  "logs.tab.comm": "Komunikačné",
  "logs.tab.app": "Aplikačný",
  "logs.detailTitle": "Log #{{id}}",
  "logs.errorsOnly": "Len chyby (4xx+5xx)",
  "logs.from": "Od",
  "logs.to": "Do",
  "logs.rowsShown": "zobrazené",
  "logs.tokenId": "Token ID",
  "logs.statusFrom": "Status od",
  "logs.statusTo": "Status do",
  "logs.records": "Záznamov",
  "logs.headerFilters": "Filter podľa hlavičiek",
  "logs.addHeader": "Pridať hlavičku",
  "logs.filter": "Filtrovať",
  "logs.reset": "Reset",
  "logs.autoRefresh": "Auto-refresh:",
  "logs.results": "výsledkov",
  "logs.includeDetails": "Vrátane detailov",
  "logs.page": "Stránka",
  "logs.total": "spolu",
  "logs.copy": "Kopírovať",
  "logs.col.server": "Server",
  "logs.col.token": "Token",
  "logs.app.lines": "Riadkov",
  "logs.app.level": "Úroveň",
  "logs.app.filter": "Filter",
  "logs.app.load": "Načítať",
  "logs.app.download": "Stiahnuť",
  "logs.app.autoScroll": "Auto-scroll",
  "logs.app.lineCount": "{{count}} riadkov (buffer {{max}})",
  "logs.copyCurl": "Kopírovať ako cURL",
  "logs.copyJson": "Kopírovať JSON",
  "logs.copied": "Skopírované",
  "logs.copyFail": "Kopírovanie zlyhalo",
  "logs.reqHeaders": "Request headers",
  "logs.reqBody": "Request body",
  "logs.resHeaders": "Response headers",
  "logs.resBody": "Response body",
  "logs.col.direction": "Smer",
  "logs.col.method": "Metóda",
  "logs.col.endpoint": "Endpoint",
  "logs.col.status": "Status",
  "logs.allLevels": "Všetko",
  "logs.empty": "Žiadne záznamy.",
  "txlogs.title": "Transakčné logy",
  "txlogs.subtitle": "Audit schválení a zamietnutí transakcií.",
  "txlogs.col.created": "Čas",
  "txlogs.col.operation": "Operácia",
  "txlogs.col.result": "Výsledok",
  "txlogs.col.duration": "Trvanie",
  "txlogs.ok": "OK",
  "txlogs.fail": "Chyba",
  "pager.pageInfo": "Stránka {{page}} z {{pages}} · {{total}} záznamov",
  "pager.prev": "Predchádzajúca",
  "pager.next": "Ďalšia",
  "txlogs.stat.total": "Operácií spolu",
  "txlogs.stat.success": "Úspešných",
  "txlogs.stat.last24h": "Za 24 h",
  "txlogs.stat.successRate": "Úspešnosť",
  "txlogs.stat.failed": "Neúspešné",
  "txlogs.stat.approves": "Schválenia",
  "txlogs.stat.rejects": "Zamietnutia",
  "txlogs.stat.avgDuration": "Prim. trvanie",
  "txlogs.filter.from": "Od",
  "txlogs.filter.to": "Do",
  "pager.pageSize": "Veľkosť stránky",
  "txlogs.filter.autoRefresh": "Auto-refresh",
  "txlogs.filter.off": "Vypnuté",
  "txlogs.filter.live": "naživo",
  "txlogs.col.txId": "Transaction ID",
  "pager.first": "Prvá",
  "pager.last": "Posledná",
  "txlogs.field.authServerTxId": "Auth Server TX ID",
  "txlogs.field.paatProfile": "PAAT profil",
  "txlogs.field.deviceAuthType": "Device Auth Type",
  "txlogs.field.createdAt": "Vytvorené",
  "txlogs.field.startedAt": "Začaté",
  "txlogs.field.completedAt": "Dokončené",
  "txlogs.field.traceId": "Trace ID",
  "txlogs.field.errorCode": "Kód chyby",
  "txlogs.field.correlationId": "Correlation ID",
  "txlogs.field.requestIp": "Request IP",
  "txlogs.field.userAgent": "User-Agent",
  "txlogs.field.mobileSdkData": "Mobile SDK Data",
  "txlogs.field.scmsHash": "SCMS Hash",
  "txlogs.detailTitle": "Transakčný log #{{id}}",
  "txlogs.field.transactionId": "Transaction ID",
  "txlogs.field.signature": "Podpis",
  "txlogs.field.signatureValue": "Hodnota podpisu",
  "txlogs.field.encryptedHash": "Hash šifrovaných dát",
  "txlogs.field.password": "Heslo",
  "txlogs.field.rejectionReason": "Dôvod zamietnutia",
  "txlogs.field.wysiwyg": "WYSIWYS dáta",
  "txlogs.field.decrypted": "Dešifrované dáta",
  "stats.title": "Štatistiky servera",
  "stats.subtitle": "Živé metriky servera (obnovované každých 5 s).",
  "stats.rps": "Požiadaviek/s",
  "stats.lastUpdate": "Posledná aktualizácia",
  "stats.manual": "Ručne",
  "stats.refreshNow": "Obnoviť teraz",
  "stats.processCpu": "Process CPU",
  "stats.systemCpu": "System CPU",
  "stats.gcLastPause": "GC posledná pauza",
  "stats.totalReq": "celkovo",
  "stats.errorRate": "Chybovosť",
  "stats.heap": "Heap pamäť",
  "stats.throughputHistory": "História throughputu",
  "stats.throughput": "Request throughput",
  "stats.last1m": "Za 1 min",
  "stats.last5m": "Za 5 min",
  "stats.last1h": "Za 1 h",
  "stats.latency": "Latency percentily",
  "stats.latencyTotal": "Celková latencia",
  "stats.latencyConnector": "Latencia konektora",
  "stats.latencyProcessing": "Latencia spracovania",
  "stats.minMaxAvg": "min / max / avg",
  "stats.errors": "Chybovosť",
  "stats.recentErrors": "Posledné chyby",
  "stats.noErrors": "Žiadne nedávne chyby.",
  "stats.dbPool": "Databázový pool",
  "stats.httpPool": "HTTP pool",
  "stats.jvm": "JVM",
  "stats.active": "Aktívne",
  "stats.idle": "Voľné",
  "stats.waiting": "Čakajúce",
  "stats.utilization": "Využitie",
  "stats.leased": "Zapožičané",
  "stats.available": "Dostupné",
  "stats.pending": "Čakajúce",
  "stats.threads": "Vlákna",
  "stats.nonHeap": "Non-heap",
  "settings.title": "Nastavenia",
  "settings.subtitle": "Konfigurácia servera, konektorov a prístupu",
  "settings.group.overview": "Prehľad",
  "settings.group.system": "Systém",
  "settings.group.operations": "Prevádzka",
  "settings.group.access": "Prístup",
  "settings.group.appearance": "Vzhľad",
  "settings.users": "Používatelia",
  "settings.connectors": "Konektory",
  "settings.maintenance": "Údržba",
  "settings.general": "Všeobecné",
  "settings.audit": "Audit",
  "settings.tls": "TLS",
  "tls.title": "TLS",
  "tls.subtitle": "Stav TLS a operácie (certifikát sa mení env premennými)",
  "tls.status": "Stav",
  "tls.https": "HTTPS aktívne",
  "tls.plainHttp": "Plain HTTP",
  "tls.protocols": "Protokoly",
  "tls.listenPort": "Načúvací port",
  "tls.httpPort": "HTTP port",
  "tls.httpsPublicPort": "Verejný HTTPS port",
  "tls.allowHttp": "Povoliť HTTP",
  "tls.redirectHttp": "HTTP→HTTPS redirect",
  "tls.forwardHeaders": "Forward headers",
  "tls.keystore": "Keystore",
  "tls.acmeDomains": "ACME domény",
  "tls.renewalDays": "Obnova (dní pred expiráciou)",
  "tls.reload": "Reload bundle",
  "tls.renew": "Obnoviť certifikát (ACME)",
  "tls.activeCert": "Aktívny certifikát",
  "tls.subject": "Subject",
  "tls.issuer": "Issuer",
  "tls.validity": "Platnosť",
  "tls.serial": "Sériové číslo",
  "tls.fingerprint": "Fingerprint",
  "tls.history": "História certifikátov",
  "tls.installed": "Nainštalované",
  "tls.expires": "Expirácia",
  "tls.source": "Zdroj",
  "tls.activeCol": "Aktívny",
  "tls.notes": "Poznámky",
  "tls.enableHintTitle": "TLS nie je aktívne (beží plain HTTP)",
  "tls.enableHint": "Nastavte ETTS_TLS_SOURCE=keystore (priame TLS) alebo terminujte TLS na reverznej proxy a nastavte SERVER_FORWARD_HEADERS_STRATEGY=framework. Pozri env referenciu nižšie.",
  "audit.title": "Auth audit log",
  "audit.subtitle": "Prihlásenia, správa používateľov a bezpečnostné udalosti",
  "audit.search": "Hľadať",
  "audit.empty": "Žiadne audit udalosti",
  "audit.detailTitle": "Detail audit udalosti",
  "audit.details": "Detaily",
  "audit.copy": "Kopírovať",
  "audit.time": "Čas",
  "audit.event": "Udalosť",
  "audit.eventGroups": "Skupiny",
  "audit.group.login": "Prihlásenie",
  "audit.group.password": "Heslá",
  "audit.group.users": "Používatelia",
  "audit.group.apiKeys": "API kľúče",
  "audit.group.security": "Bezpečnosť",
  "audit.outcome": "Výsledok",
  "audit.actor": "Aktér",
  "audit.ip": "IP adresa",
  "audit.target": "Cieľ",
  "account.title": "Účet",
  "account.subtitle": "Váš profil a zmena hesla",
  "account.username": "Používateľské meno",
  "account.displayName": "Zobrazované meno",
  "account.email": "E-mail",
  "account.roles": "Role",
  "account.authSource": "Zdroj autentizácie",
  "account.bootstrap": "Bootstrap admin",
  "account.mustChange": "Vynútiť zmenu hesla",
  "account.ldapNote": "Tento účet sa overuje voči externému adresáru (LDAP). Heslo zmeňte tam.",
  "account.changePassword": "Zmena hesla",
  "account.locked.title": "Zmena hesla je pre toto nasadenie uzamknutá",
  "account.locked.detail": "Funkcia Správa používateľov (admin.user-management) nie je povolená vo vašom licenčnom tieri, takže je formulár zmeny hesla v aplikácii deaktivovaný.",
  "account.locked.bootstrapIntro": "Ste prihlásený ako bootstrap admin. Rotácia hesla tohto účtu:",
  "account.locked.bootstrapStep1": "Zmeňte ETTS_INITIAL_ADMIN_PASSWORD vo svojom prostredí.",
  "account.locked.bootstrapStep2": "Uistite sa, že ETTS_BOOTSTRAP_SYNC_PWD=true (predvolené v docker-compose.yml).",
  "account.locked.bootstrapStep3": "Reštartujte aplikáciu — bootstrap admin heslo sa pri štarte znovu zosynchronizuje.",
  "account.locked.nonbootstrap": "Požiadajte administrátora so shell prístupom o rotáciu hesla, alebo upgradujte licenciu pre povolenie správy používateľov.",
  "account.advertised.title": "Samoobslužná zmena hesla čoskoro dorazí",
  "account.advertised.detail": "Funkcia Správa používateľov je plánovaná pre budúce vydanie vášho tieru. Dovtedy heslo žije v bootstrap konfigurácii z prostredia; viď ETTS_INITIAL_ADMIN_PASSWORD.",
  "account.current": "Aktuálne heslo",
  "account.new": "Nové heslo",
  "account.confirm": "Potvrdiť heslo",
  "account.save": "Zmeniť heslo",
  "account.changed": "Heslo bolo zmenené.",
  "account.mismatch": "Nové heslo a potvrdenie sa nezhodujú.",
  "account.tooShort": "Heslo musí mať aspoň 12 znakov.",
  "settings.tokenSettings": "Nastavenia tokenov",
  "settings.uiSettings": "UI nastavenia",
  "settings.appearance": "Vzhľad",
  "appearance.title": "Vzhľad",
  "appearance.subtitle": "Vyberte motív aplikácie. Motív sa ukladá do tohto prehliadača, jazyk k vášmu účtu.",
  "appearance.system": "Systém",
  "appearance.system.desc": "Podľa nastavenia systému",
  "appearance.light": "Svetlý",
  "appearance.light.desc": "Vždy svetlý motív",
  "appearance.dark": "Tmavý",
  "appearance.dark.desc": "Vždy tmavý motív",
  "common.confirm": "Potvrdiť",
  "tokenSettings.title": "Nastavenia tokenov",
  "tokenSettings.subtitle": "Režim inštancií (jedna/viac aktívnych inštancií na licenciu)",
  "tokenSettings.currentMode": "Aktuálny režim",
  "tokenSettings.buildProfile": "Build profil",
  "tokenSettings.default": "Predvolený",
  "tokenSettings.setSingle": "Prepnúť na SINGLE",
  "tokenSettings.setMulti": "Prepnúť na MULTI",
  "tokenSettings.switchTitle": "Zmena režimu inštancií",
  "tokenSettings.switchSingleWarn": "Prepnutie na SINGLE deaktivuje prebytočné aktívne inštancie na každej licencii. Pokračovať?",
  "tokenSettings.switchMultiInfo": "Prepnúť na MULTI (viac aktívnych inštancií na licenciu)?",
  "tokenSettings.cleanupDone": "Deaktivovaných {{tokens}} tokenov na {{licences}} licenciách.",
  "uiSettings.title": "UI nastavenia",
  "uiSettings.subtitle": "Viditeľnosť položiek navigácie",
  "uiSettings.saved": "Uložené",
  "uiSettings.showAll": "Zobraziť všetko",
  "uiSettings.hideAll": "Skryť všetko",
  "uiSettings.resetDefaults": "Obnoviť predvolené",
  "general.title": "Všeobecné",
  "general.subtitle": "Runtime a HTTP klient (read-only)",
  "general.runtime": "Runtime",
  "general.httpClient": "HTTP klient",
  "general.noHttp": "Bez konfigurácie",
  "general.envNote": "Konfigurácia sa mení env premennými pri nasadení.",
  "general.activeGlobalTls": "Aktívne globálne TLS verzie",
  "general.poolMonitorNote": "HttpPoolMonitor loguje stav poolu každých 60 s; metriky sú dostupné cez Prometheus (/actuator/prometheus).",
  "general.envReference": "Env premenné connection-poolu",
  "general.env.poolMaxTotal": "Max. celkovo poolovaných spojení",
  "general.env.poolMaxPerRoute": "Max. spojení na route",
  "general.env.connectTimeout": "Connect timeout (ms)",
  "general.env.readTimeout": "Read timeout (ms)",
  "general.env.tlsVersions": "Odchádzajúce TLS verzie",
  "tls.envReference": "TLS env premenné",
  "tls.env.source": "Zdroj TLS (none / keystore / acme)",
  "tls.env.hsts": "Zapnúť HSTS hlavičku",
  "tls.env.httpsPort": "Verejný HTTPS port",
  "tls.env.allowHttp": "Povoliť plain HTTP popri HTTPS",
  "tls.env.forwardHeaders": "Stratégia forwarded-headers (reverzná proxy)",
  "maintenance.title": "Údržba",
  "maintenance.subtitle": "Štatistiky, čistenie dát, zálohy a export/import tokenov",
  "maintenance.stats": "Štatistiky databázy",
  "maintenance.refreshStats": "Obnoviť štatistiky",
  "maintenance.schedulers": "Automatické úlohy (schedulery)",
  "maintenance.autoCleanupScheduler": "Automatické čistenie logov",
  "maintenance.tokenExpirationScheduler": "Expirácia tokenov",
  "maintenance.enabled": "Zapnuté",
  "maintenance.retentionDays": "Retencia (dni)",
  "maintenance.lastRun": "Posledný beh",
  "maintenance.httpLogs": "HTTP logy",
  "maintenance.txLogs": "Transakčné logy",
  "maintenance.tokensTotal": "Tokeny spolu",
  "maintenance.tokensActive": "Aktívne tokeny",
  "maintenance.cleanupHttp": "Čistenie HTTP komunikačných logov",
  "maintenance.cleanupTx": "Čistenie transakčných logov",
  "maintenance.cleanupActivationEvents": "Upratovanie aktivačných udalostí",
  "maintenance.cleanupTokens": "Čistenie tokenov",
  "maintenance.olderThanDays": "Staršie ako (dní)",
  "maintenance.olderThanDaysOpt": "Staršie ako (dní, voliteľné)",
  "maintenance.preview": "Náhľad",
  "maintenance.delete": "Zmazať",
  "maintenance.wouldDelete": "Na zmazanie: {{count}} záznamov",
  "maintenance.deleted": "Zmazané: {{count}} záznamov",
  "maintenance.cleanupConfirm": "Zmazať záznamy staršie ako {{days}} dní?",
  "maintenance.tokenCleanupConfirm": "Zmazať tokeny v stavoch: {{states}}? Súvisiace transakcie sa zmažú kaskádovo.",
  "maintenance.backups": "Zálohy databázy",
  "maintenance.createBackup": "Vytvoriť zálohu",
  "maintenance.noBackups": "Žiadne zálohy",
  "maintenance.restore": "Obnoviť",
  "maintenance.restoreConfirm": "Obnoviť databázu zo zálohy {{filename}}? PREPÍŠE všetky aktuálne dáta.",
  "maintenance.deleteBackupConfirm": "Zmazať zálohu {{filename}}?",
  "maintenance.exportImport": "Export / Import tokenov",
  "maintenance.export": "Export",
  "maintenance.import": "Import",
  "maintenance.includePasswords": "Vrátane hesiel",
  "maintenance.activeCascadeWarning": "Mazanie ACTIVE tokenov kaskáduje — súvisiace dáta sa zmažú. Nebezpečné!",
  "maintenance.includeActivationEvents": "Vrátane aktivačných udalostí",
  "maintenance.exportBtn": "Exportovať",
  "maintenance.overwrite": "Prepísať existujúce",
  "maintenance.importBtn": "Importovať",
  "maintenance.importPreview": "Spolu {{total}} · nových {{fresh}} · existujúcich {{existing}}",
  "maintenance.imported": "Aktualizované {{updated}} · preskočené {{skipped}} · zlyhalo {{failed}}",
  "maintenance.dangerZone": "Nebezpečná zóna",
  "maintenance.fullReset": "Kompletný reset DB",
  "maintenance.fullResetDesc": "Zmaže VŠETKY dáta z databázy. Len pre vývoj/testovanie.",
  "maintenance.fullResetConfirm": "Naozaj zmazať VŠETKY dáta? Nevratné.",
  "maintenance.typeReset": "Pre potvrdenie napíš RESET:",
  "connectors.title": "Konektory",
  "connectors.reset": "Reset",
  "connectors.resetConfirm": "Vrátiť konektor {{type}} na predvolenú konfiguráciu? Prepíše aktuálne nastavenie.",
  "connectors.editHint": "Prázdne/maskované (****) hodnoty credentials sa pri uložení zachovajú.",
  "connectors.enabledLabel": "Konektor povolený",
  "connectors.enable": "Povoliť konektor",
  "connectors.disable": "Zakázať konektor",
  "connectors.credentials": "Prihlasovacie údaje",
  "connectors.tabGeneral": "Všeobecné",
  "connectors.configJson": "Konfigurácia (JSON)",
  "connectors.credsJson": "Credentials (JSON)",
  "connectors.credsHint": "Ponechaj **** alebo prázdne pre zachovanie existujúceho tajomstva.",
  "connectors.invalidConfigJson": "Neplatný JSON v konfigurácii.",
  "connectors.invalidCredsJson": "Neplatný JSON v credentials.",
  "connectors.subtitle": "Stav a test pripojenia auth serverov.",
  "connectors.none": "Žiadne konektory nie sú k dispozícii.",
  "connectors.enabled": "Zapnutý",
  "connectors.disabled": "Vypnutý",
  "connectors.test": "Test pripojenia",
  "connectors.testing": "Testujem…",
  "connectors.enableFirst": "Najprv povoľte konektor",
  "connectors.config": "Konfigurácia",
  "connectors.ok": "Pripojenie funguje",
  "connectors.fail": "Pripojenie zlyhalo",
  "connectors.route": "Trasa",
  "connectors.route.direct": "priamo",
  "connectors.route.proxy": "cez proxy {{target}}",
  "connectors.degraded": "Odpovedal niekto iný než cieľový server",
  "connectors.detail.PROBE_ENDPOINT_UNAVAILABLE": "Brána odpovedala {{status}} — overovací endpoint v tomto prostredí nie je",
  "connectors.detail.REQUIRES_AUTHENTICATION": "Server odpovedal, endpoint vyžaduje prihlásenie",
  "connectors.detail.NOT_FROM_TARGET_SERVER": "Odpoveď neprišla z cieľového servera — pravdepodobne ju vrátila proxy",
  "settings.apiKeys": "API kľúče",
  "apikeys.title": "API kľúče",
  "apikeys.subtitle": "API klienti a ich kľúče pre programový prístup.",
  "apikeys.usage.intro": "Kľúč sa posiela v hlavičke Authorization so schémou ApiKey:",
  "apikeys.usage.notBearer": "Schéma Bearer je vyhradené pre JWT z /api/v1/auth/login — kľúč poslaný ako Bearer vráti 401 bez ohľadu na role a scopes.",
  "apikeys.usage.help": "Podrobnosti v nápovede",
  "apikeys.usage.modalHint": "Posielajte v hlavičke Authorization so schémou ApiKey (nie Bearer).",
  "apikeys.addClient": "Pridať klienta",
  "apikeys.noClients": "Žiadni API klienti.",
  "apikeys.enabled": "Aktívny",
  "apikeys.disabled": "Neaktívny",
  "apikeys.addKey": "Nový kľúč",
  "apikeys.noKeys": "Žiadne kľúče.",
  "apikeys.keys": "Kľúče",
  "apikeys.label": "Popisok",
  "apikeys.scopes": "Scopes",
  "apikeys.roles": "Role",
  "apikeys.created": "Vytvorený",
  "apikeys.lastUsed": "Naposledy použitý",
  "apikeys.revoked": "Odvolaný",
  "apikeys.active": "Aktívny",
  "apikeys.revoke": "Odvolať",
  "apikeys.name": "Názov",
  "apikeys.description": "Popis",
  "apikeys.nameRequired": "Zadajte názov.",
  "apikeys.newKey": "Nový API kľúč",
  "apikeys.needScopeOrRole": "Vyberte aspoň jednu rolu alebo scope.",
  "apikeys.ttl": "Platnosť (dni)",
  "apikeys.ttlNever": "Bez expirácie",
  "apikeys.generate": "Vygenerovať",
  "apikeys.copyNow": "Skopírujte kľúč teraz — už sa znovu nezobrazí.",
  "apikeys.copy": "Kopírovať",
  "apikeys.deleteClientTitle": "Zmazať klienta",
  "apikeys.deleteClientConfirm": "Naozaj zmazať klienta {{name}} vrátane všetkých kľúčov?",
  "common.delete": "Zmazať",
  "common.done": "Hotovo",
  "settings.directory": "Directory (LDAP)",
  "directory.title": "Directory (LDAP)",
  "directory.subtitle": "Prehľad adresárových providerov a test spojenia.",
  "directory.none": "Žiadny LDAP provider nie je nakonfigurovaný.",
  "directory.available": "Dostupný",
  "directory.unavailable": "Nedostupný",
  "directory.filter": "User filter",
  "directory.lastSuccess": "Posledný úspech",
  "directory.lastFailure": "Posledná chyba",
  "directory.ok": "Spojenie funguje",
  "directory.fail": "Spojenie zlyhalo",
  "settings.license": "Licencia",
  "license.title": "Licencia",
  "license.subtitle": "Informácie o licencii a aktivácia kľúča.",
  "license.customer": "Zákazník",
  "license.tier": "Tier",
  "license.status": "Stav",
  "license.valid": "Platná",
  "license.invalid": "Neplatná",
  "license.validFrom": "Platná od",
  "license.validTo": "Platná do",
  "license.modules": "Aktívne moduly",
  "license.features": "Funkcie",
  "license.enabled": "aktívnych",
  "license.advertised": "avizovaných",
  "license.locked": "zamknutých",
  "license.featuresByModule": "Funkcie podľa modulu",
  "license.featuresCount": "funkcií",
  "license.plannedFeatures": "Plánované funkcie",
  "license.runtimeExpiry": "Runtime aktivácia do",
  "license.activate": "Aktivovať",
  "license.activateHint": "Vložte licenčný kľúč pre odomknutie ďalších modulov za behu.",
  "license.keyRequired": "Zadajte licenčný kľúč.",
  "license.activated": "Licencia aktivovaná.",
  "license.activateFailed": "Aktivácia zlyhala.",
  "users.title": "Používatelia",
  "users.subtitle": "Správa používateľských účtov a rolí.",
  "users.add": "Pridať používateľa",
  "users.editTitle": "Upraviť používateľa",
  "users.deleteTitle": "Zmazať používateľa",
  "users.deleteConfirm": "Naozaj zmazať používateľa {{username}}? Túto akciu nemožno vrátiť.",
  "users.resetPassword": "Zmeniť heslo",
  "users.newPassword": "Nové heslo",
  "users.edit": "Upraviť",
  "users.delete": "Zmazať",
  "users.enabled": "Aktívny",
  "users.disabled": "Deaktívny",
  "users.enabledLabel": "Účet aktívny",
  "users.pwMin": "Heslo musí mať aspoň 12 znakov.",
  "users.rolesMin": "Vyberte aspoň jednu rolu.",
  "users.col.username": "Používateľské meno",
  "users.col.displayName": "Zobrazované meno",
  "users.col.roles": "Role",
  "users.role.admin.desc": "Plný prístup — správa používateľov, konektorov, tokenov aj nastavení.",
  "users.role.operator.desc": "Prevádzkové operácie nad tokenmi a transakciami bez správy používateľov.",
  "users.role.viewer.desc": "Iba na čítanie — prehľady, logy a štatistiky.",
  "users.roles.hint": "Každá rola sa rozbaľuje do viacerých oprávnení (scopes).",
  "users.col.status": "Stav",
  "users.col.source": "Zdroj",
  "users.col.lockedUntil": "Uzamknuté do",
  "users.authSource": "Zdroj autentizácie",
  "users.externalId": "Externý identifikátor",
  "users.extIdRequired": "Externý identifikátor je povinný pre LDAP.",
  "users.changeAuthSource": "Zmeniť zdroj autentizácie",
  "users.newPasswordOptional": "Nové heslo (voliteľné)",
  "users.recentAudit": "Nedávny auth audit",
  "users.recentAudit.showAll": "Zobraziť celý audit",
  "users.col.lastLogin": "Posledné prihlásenie",
  "common.cancel": "Zrušiť",
  "common.save": "Uložiť",
  "common.loading": "Načítavam…",
  "common.loadError": "Nepodarilo sa načítať dáta.",
  "testing.title": "Testovacie nástroje",
  "testing.subtitle": "Interaktívne nástroje na overenie integrácie s auth servermi",
  "testing.activation": "Aktivácia",
  "testing.activation.title": "Test aktivácie tokenu",
  "testing.activation.subtitle": "Interaktívny nástroj so živým sledovaním priebehu",
  "testing.activation.params": "Parametre testu",
  "testing.activation.noAuthServers": "Žiadny podporovaný konektor nie je aktívny",
  "testing.activation.start": "Spustiť test",
  "testing.activation.success": "Aktivácia úspešná",
  "testing.activation.failed": "Aktivácia zlyhala",
  "testing.field.authServer": "Typ auth servera",
  "testing.field.username": "Používateľské meno",
  "testing.field.otp": "OTP",
  "testing.field.password": "Heslo",
  "testing.field.activationGuid": "Aktivačné GUID",
  "testing.field.expiresInSeconds": "Platnosť (s)",
  "testing.field.expiresInSeconds.placeholder": "bez expirácie",
  "testing.field.tags": "Tagy",
  "testing.field.tags.placeholder": "oddelené čiarkou, napr. smoke, zataz",
  "testing.field.pushIdentifier": "Push identifikátor (FCM token)",
  "testing.field.applicationId": "Application ID",
  "testing.field.deviceType": "Device Type",
  "testing.field.deviceType.hint": "Voliteľné — predvolené 34. Nastav len pri testovaní alternatívnych kódov zariadenia.",
  "testing.field.paatProfile": "PAAT profil (info o zariadení)",
  "testing.field.paatProfile.default": "-- Použiť predvolený profil --",
  "testing.field.guidOptional": "Aktivačné GUID (voliteľné)",
  "testing.generate": "Generovať",
  "testing.running": "Prebieha…",
  "testing.connectorSpecific": "Špecifické pre konektor",
  "testing.progress": "Priebeh testu",
  "testing.httpCalls": "HTTP volania",
  "testing.httpLog": "HTTP komunikačný log",
  "testing.viewToken": "Zobraziť detail tokenu",
  "testing.runAnother": "Spustiť ďalší test",
  "testing.exportJson": "Export (JSON)",
  "testing.exportCsv": "Export (CSV)",
  "testing.validation.required": "Vyplňte prosím všetky povinné polia",
  "testing.validation.appIdRequired": "Application ID je povinné pre eCobra",
  "testing.validate.title": "Overiť aktiváciu (získať Bearer token)",
  "testing.validate.submit": "Overiť a získať token",
  "testing.validate.running": "Overujem…",
  "testing.validate.success": "Overenie úspešné",
  "testing.validate.failed": "Overenie zlyhalo",
  "testing.validate.copyFromMain": "Skopírovať z hlavného formulára",
  "testing.validate.copyToken": "Kopírovať token",
  "testing.otp": "OTP / heslo",
  "testing.otp.title": "Test OTP a správy hesla",
  "testing.otp.subtitle": "Generovanie OTP, zmena hesla a overenie OTP so živým priebehom",
  "testing.otp.scenario": "Scenár (predvyplnenie)",
  "testing.otp.scenarioNone": "-- Vyberte scenár --",
  "testing.otp.mode": "Režim testu",
  "testing.otp.mode.OTP_GENERATION": "Generovanie OTP",
  "testing.otp.mode.PASSWORD_CHANGE": "Zmena hesla",
  "testing.otp.mode.OTP_VERIFY": "Overenie OTP",
  "testing.otp.tokenId": "Token ID",
  "testing.otp.tokenRequired": "Token ID je povinné",
  "testing.otp.currentPassword": "Aktuálne heslo",
  "testing.otp.currentPwRequired": "Aktuálne heslo je povinné pre generovanie OTP",
  "testing.otp.oldPassword": "Staré heslo",
  "testing.otp.newPassword": "Nové heslo",
  "testing.otp.oldNewPwRequired": "Staré aj nové heslo sú povinné",
  "testing.otp.newPwMin": "Nové heslo musí mať aspoň 4 znaky",
  "testing.otp.otpCode": "OTP kód",
  "testing.otp.otpRequired": "OTP kód je povinný pre overenie",
  "testing.otp.start": "Spustiť test",
  "testing.otp.success": "Test úspešný",
  "testing.otp.failed": "Test zlyhal",
  "testing.otp.generatedOtp": "Vygenerované OTP",
  "testing.otp.expiresAt": "Platné do",
  "testing.otp.passwordChanged": "Heslo zmenené",
  "testing.otp.otpValid": "OTP platné",
  "testing.otp.help.generation": "Vygeneruje nový OTP kód pre token (vyžaduje aktuálne heslo)",
  "testing.otp.help.passwordChange": "Zmení heslo tokenu (vyžaduje staré a nové heslo)",
  "testing.otp.help.verify": "Overí OTP kód na auth serveri (eCobra alebo CSOB eChannels)",
  "testing.duration": "Doba trvania",
  "testing.completedAt": "Dokončené",
  "common.yes": "Áno",
  "common.no": "Nie",
  "testing.dr": "Výmena zariadenia",
  "testing.dr.title": "Test výmeny zariadenia",
  "testing.dr.subtitle": "Workflow create → process (QR sekvencie) → complete so živým priebehom",
  "testing.dr.scenario": "Scenár (predvyplnenie)",
  "testing.dr.scenarioNone": "-- Vyberte scenár --",
  "testing.dr.tokenId": "Token ID",
  "testing.dr.tokenRequired": "Token ID je povinné",
  "testing.dr.message": "Správa (voliteľné)",
  "testing.dr.autoProcess": "Automaticky spracovať po vytvorení",
  "testing.dr.autoComplete": "Auto-complete (vyžaduje nový aktivačný GUID)",
  "testing.dr.simulateQrDelay": "Simulovať oneskorenie skenovania QR",
  "testing.dr.qrDelayMs": "Oneskorenie (ms)",
  "testing.dr.start": "Spustiť test",
  "testing.dr.qrCodes": "QR sekvencie",
  "testing.dr.qrSequence": "Sekvencia {{index}} z {{total}}",
  "testing.dr.qrHelp": "Toto by sa na pôvodnom zariadení zobrazilo ako QR kód",
  "testing.dr.success": "Test výmeny zariadenia úspešný",
  "testing.dr.completedWarn": "Dokončené s upozorneniami",
  "testing.dr.failed": "Test zlyhal",
  "testing.dr.errorType": "Typ chyby",
  "testing.dr.stepsBeforeFailure": "Kroky dokončené pred zlyhaním",
  "testing.dr.originalTokenId": "Pôvodné Token ID",
  "testing.dr.transactionId": "ID transakcie",
  "testing.dr.qrSequenceCount": "Počet QR sekvencií",
  "testing.dr.newActivationGuid": "Nové aktivačné GUID",
  "testing.dr.newTokenId": "Nové Token ID",
  "testing.dr.stepsExecuted": "Vykonané kroky",
  "testing.dr.viewOriginal": "Detail pôvodného tokenu",
  "testing.dr.viewNew": "Detail nového tokenu",
  "testing.admin": "Admin operácie",
  "testing.admin.title": "Test admin operácií",
  "testing.admin.subtitle": "Vyhľadávanie, hromadná deaktivácia, health check a log operácie",
  "testing.admin.scenario": "Scenár (predvyplnenie)",
  "testing.admin.scenarioNone": "-- Vyberte scenár --",
  "testing.admin.mode": "Režim testu",
  "testing.admin.mode.TOKEN_SEARCH": "Vyhľadanie tokenov",
  "testing.admin.mode.BULK_DEACTIVATE": "Hromadná deaktivácia",
  "testing.admin.mode.HEALTH_CHECK": "Health check",
  "testing.admin.mode.LOG_EXPORT": "Export logov",
  "testing.admin.mode.LOG_STATISTICS": "Štatistiky logov",
  "testing.admin.mode.LOG_CLEANUP": "Čistenie logov",
  "testing.admin.help.search": "Vyhľadá tokeny podľa filtrov (meno, stav, typ auth servera)",
  "testing.admin.help.bulk": "Deaktivuje viacero tokenov naraz — DEŠTRUKTÍVNA operácia",
  "testing.admin.help.health": "Skontroluje stav databázy a všetkých auth serverov",
  "testing.admin.help.export": "Exportuje komunikačné logy do JSON alebo CSV",
  "testing.admin.help.stats": "Vypočíta štatistiky komunikačných logov",
  "testing.admin.help.cleanup": "Zmaže staré logy (s voliteľným dry-run)",
  "testing.admin.any": "-- Všetko --",
  "testing.admin.usernameFilter": "Filter používateľského mena",
  "testing.admin.stateFilter": "Filter stavu",
  "testing.admin.authServerFilter": "Filter typu auth servera",
  "testing.admin.maxResults": "Max výsledkov",
  "testing.admin.tokenIds": "Token ID (oddelené čiarkou)",
  "testing.admin.tokenIdsHint": "Napr. ECT0000000001-1, ECT0000000002-1",
  "testing.admin.tokenIdsRequired": "Zadajte aspoň jedno Token ID",
  "testing.admin.deactivationReason": "Dôvod deaktivácie",
  "testing.admin.bypassAuthServer": "Obísť auth server (len lokálna deaktivácia)",
  "testing.admin.bulkConfirm": "Potvrdzujem hromadnú deaktiváciu uvedených tokenov",
  "testing.admin.bulkConfirmRequired": "Potvrďte hromadnú deaktiváciu zaškrtnutím",
  "testing.admin.exportFormat": "Formát exportu",
  "testing.admin.daysToExport": "Počet dní",
  "testing.admin.statisticsDays": "Obdobie (dní)",
  "testing.admin.retentionDays": "Retencia (dní)",
  "testing.admin.dryRun": "Dry run (len simulácia, nemaže)",
  "testing.admin.dryRunLabel": "DRY RUN",
  "testing.admin.start": "Spustiť test",
  "testing.admin.success": "Test úspešný",
  "testing.admin.failed": "Test zlyhal",
  "testing.admin.totalMatches": "Počet zhôd",
  "testing.admin.deactivated": "Deaktivované",
  "testing.admin.failedCount": "Zlyhalo",
  "testing.admin.errors": "Chyby",
  "testing.admin.healthStatus": "Celkový stav",
  "testing.admin.database": "Databáza",
  "testing.admin.activeTokens": "Aktívne tokeny",
  "testing.admin.exportedLogs": "Exportovaných logov",
  "testing.admin.exportSize": "Veľkosť",
  "testing.admin.totalLogs": "Celkovo logov",
  "testing.admin.errors24h": "Chyby (24 h)",
  "testing.admin.errorRate": "Chybovosť",
  "testing.admin.deletedLogs": "Zmazaných logov",
  "testing.admin.authServer": "Auth server",
  "testing.admin.requests": "Požiadavky",
  "testing.admin.avgResponse": "Priem. odozva",
  "apitools.nav": "API Tools",
  "apitools.title": "API Tools",
  "apitools.subtitle": "Interaktívny REST request builder proti eTTS a konektorom",
  "apitools.execute": "Spustiť",
  "apitools.executeHint": "Vyberte operáciu a spustite pre zobrazenie odpovede",
  "apitools.includeStats": "Zahrnúť štatistiky (X-API-Stats)",
  "apitools.required": "Pole „{{field}}\" je povinné",
  "apitools.requiredOneOf": "Vyplňte aspoň jedno z polí: {{fields}}",
  "apitools.success": "Úspech",
  "apitools.error": "Chyba",
  "apitools.response": "Odpoveď",
  "apitools.requestHeaders": "Hlavičky requestu",
  "apitools.requestBody": "Telo requestu",
  "apitools.selectToken": "-- Vyberte token --",
  "apitools.selectAuthServer": "-- Vyberte auth server --",
  "apitools.any": "-- Všetko --",
  "apitools.validPin": "Platný PIN",
  "apitools.invalidPin": "Neplatný PIN",
  "apitools.authorization": "Autorizácia",
  "apitools.auth.none": "Žiadna (anonymná)",
  "apitools.auth.adminJwt": "Môj admin JWT (cookie)",
  "apitools.auth.apikey": "API kľúč",
  "apitools.auth.bearer": "Bearer token",
  "apitools.auth.customRaw": "Vlastná (verbatim)",
  "apitools.customHeaders": "Vlastné hlavičky",
  "apitools.headerName": "Názov hlavičky",
  "apitools.headerValue": "Hodnota",
  "apitools.addHeader": "Pridať hlavičku",
  "apitools.attrKey": "kľúč (napr. applicationId)",
  "apitools.attrValue": "hodnota",
  "apitools.addAttr": "Pridať atribút",
  "apitools.sessionStale.title": "Relácia vypršala",
  "apitools.sessionStale.body": "Request bol odmietnutý bezpečnostnou vrstvou (typicky zastaraný CSRF token po reštarte). Obnovte stránku (Ctrl+Shift+R) a skúste znova.",
  "apitools.stats.total": "Celkovo",
  "apitools.stats.connector": "Konektor",
  "apitools.stats.calls": "API volania",
  "apitools.stats.processing": "Spracovanie",
  "apitools.stats.connectorCalls": "Volania konektora (detail)",
  "apitools.genValidOtp": "Generovať platný OTP",
  "apitools.genInvalidOtp": "Generovať neplatný OTP",
  "apitools.op.activateToken": "Aktivovať token",
  "apitools.op.listTokens": "Zoznam tokenov",
  "apitools.op.getToken": "Detail tokenu",
  "apitools.op.instanceInfo": "Stav tokenu",
  "apitools.f.syncState": "Uložiť zistený stav do tokenu",
  "apitools.f.syncState.hint": "Bez zaškrtnutia sa stav iba prečíta z auth servera (GET /api/v1/tokens/{id}/instance-info). So zaškrtnutím sa navyše uloží do tokenu (POST /admin/api/v1/tokens/{id}/sync-state) a odpoveď ukáže pôvodný aj nový stav.",
  "apitools.op.deactivateToken": "Deaktivovať token",
  "apitools.op.generateOtp": "Generovať OTP",
  "apitools.op.verifyOtp": "Overiť OTP",
  "apitools.f.authServerType": "Typ auth servera",
  "apitools.f.username": "Používateľské meno",
  "apitools.f.otp": "OTP",
  "apitools.f.password": "Heslo",
  "apitools.f.activationGuid": "Aktivačné GUID",
  "apitools.f.paatProfile": "PAAT profil",
  "apitools.f.testTraceId": "Test Trace ID",
  "apitools.f.expiresInSeconds": "Platnosť (s)",
  "apitools.f.expiresInSeconds.hint": "Voliteľné TTL tokenu v sekundách",
  "apitools.f.tags": "Tagy",
  "apitools.f.tags.hint": "Oddelené čiarkou",
  "apitools.f.connectorAttributes": "Atribúty konektora",
  "apitools.generate": "Generovať",
  "apitools.f.pushIdentifier": "Push Identifier",
  "apitools.f.applicationId": "Application ID",
  "apitools.f.isMigration": "Migrácia",
  "apitools.f.deviceType": "Device Type",
  "apitools.f.activationMethod": "Metóda aktivácie",
  "apitools.f.appType": "App Type",
  "apitools.f.applicationName": "Application Name",
  "apitools.f.kbId": "KBID (identifikátor klienta)",
  "apitools.f.kbId.hint": "Vyplňte, len keď používateľské meno nie je KBID — overovacie OTP sa hľadá podľa KBID",
  "apitools.f.sourceTokenId": "Zdrojový token",
  "apitools.f.accessToken": "Access Token (override)",
  "apitools.f.accessToken.hint": "Prázdne = použiť token uložený pri zdrojovom tokene",
  "apitools.f.codeVerifier": "Code Verifier (override)",
  "apitools.f.codeVerifier.hint": "Prázdne = použiť PKCE verifier zdrojového tokenu",
  "apitools.f.state": "Stav",
  "apitools.f.tag": "Tag",
  "apitools.f.tokenId": "Token",
  "apitools.group.token": "Tokeny",
  "apitools.group.tx": "Transakcie",
  "apitools.group.dr": "Výmena zariadenia",
  "apitools.op.pendingTransactions": "Čakajúce transakcie",
  "apitools.op.transactionDetail": "Detail transakcie",
  "apitools.op.approveTransaction": "Schváliť transakciu",
  "apitools.op.rejectTransaction": "Zamietnuť transakciu",
  "apitools.op.createDeviceReplacement": "Vytvoriť výmenu",
  "apitools.op.processDeviceReplacement": "Spracovať výmenu",
  "apitools.op.verifyActivation": "Overiť aktiváciu",
  "apitools.op.assembleSequences": "Zostaviť sekvencie",
  "apitools.f.ippids": "IPPIDs",
  "apitools.f.ippids.hint": "Prázdne = auto z username tokenu",
  "apitools.f.status": "Stav",
  "apitools.f.status.all": "0 — všetko",
  "apitools.f.transactionId": "ID transakcie",
  "apitools.f.transactionId.hint": "GUID pre eChannels, operationId pre eCobra",
  "apitools.f.limit": "Limit",
  "apitools.f.includeDetails": "Vrátane detailov",
  "apitools.f.secureMessage": "Secure Message",
  "apitools.f.secureMessage.hint": "Base64 podpisované dáta",
  "apitools.f.passwordType": "Typ hesla (podpis)",
  "apitools.f.recognitionType": "Recognition Type",
  "apitools.f.mode": "Režim",
  "apitools.f.reason": "Dôvod",
  "apitools.f.sequences": "Sekvencie (JSON pole)",
  "apitools.f.sequences.hint": "JSON pole QR sekvencií",
  "apitools.invalidJsonArray": "Neplatné JSON pole (musí byť neprázdne)",
  "apitools.dr.nextStep": "Ďalší krok:",
  "apitools.dr.approve": "Schváliť",
  "apitools.dr.reject": "Zamietnuť",
  "apitools.dr.fillVerify": "Predvyplniť Overiť aktiváciu",
  "apitools.dr.fillAssemble": "Predvyplniť Zostaviť sekvencie",
  "apitools.group.kbcaas": "KB CAAS",
  "apitools.op.kbCaasGetInstanceInfo": "Info o inštancii",
  "apitools.op.kbCaasEvaluateDevice": "Evaluate Device",
  "apitools.op.kbCaasInitContext": "Init Context",
  "apitools.op.kbCaasDictionaryLatest": "Slovník — posledná verzia",
  "apitools.op.kbCaasGetDictionary": "Slovník — verzia",
  "apitools.f.version": "Verzia",
  "apitools.dict.title": "Lokálna cache slovníkov",
  "apitools.dict.refresh": "Obnoviť",
  "apitools.dict.empty": "Žiadne uložené slovníky",
  "apitools.dict.version": "Verzia",
  "apitools.dict.fetchedAt": "Stiahnuté",
  "apitools.dict.size": "Veľkosť",
  "apitools.dict.view": "Zobraziť",
  "apitools.group.privat": "Privat banka",
  "apitools.op.privatLogin": "Prihlásenie (získať Bearer token)",
  "apitools.op.privatInvalidateLogin": "Zahodiť uložený token",
  "apitools.f.forceLogin": "Vynútiť nové prihlásenie",
  "apitools.f.forceLogin.hint": "Ignoruje token uložený v pamäti a prejde oba kroky znova.",
  "apitools.privatToken.title": "Bearer token pre Privat Mobile API",
  "apitools.privatToken.hint": "Bez access tokenu neprejde žiadne volanie na ich API. Server si ho pre nástroje v administrácii obstaráva sám; tu je vidieť, či nejaký drží, a dá sa získať ručne.",
  "apitools.privatToken.held": "Token držaný",
  "apitools.privatToken.none": "Žiadny token",
  "apitools.privatToken.autoLoginOff": "Auto-login vypnutý",
  "apitools.privatToken.obtain": "Získať token",
  "apitools.privatToken.refresh": "Získať znova",
  "apitools.privatToken.discard": "Zahodiť",
  "apitools.privatToken.obtainedAt": "Získaný",
  "apitools.privatToken.validUntil": "Platí do",
  "apitools.privatToken.remaining": "zostáva {{seconds}} s",
  "apitools.privatToken.source": "Zdroj",
  "apitools.privatToken.estimated": "Platnosť je odhad Test Token Servera — Privat Mobile API dobu platnosti ani refresh token nevracia. Token môže prestať platiť skôr; po odmietnutí (401) sa získa znova.",
  "apitools.privatToken.failed": "Prihlásenie zlyhalo v kroku „{{step}}\"",
  "apitools.pending.title": "Čakajúce transakcie ({{count}})",
  "apitools.pending.hint": "Vyčítané operáciou Čakajúce transakcie. Tlačidlá prepnú na príslušnú záložku a predvyplnia parametre — odoslať ich musíš tam, takže sa dá ešte upraviť voľba hesla aj režim.",
  "apitools.pending.refresh": "Obnoviť",
  "apitools.pending.refreshFailed": "Obnovenie fronty zlyhalo",
  "apitools.pending.expiresAt": "Vyprší",
  "apitools.pending.message": "Správa",
  "apitools.pending.detail": "Detail",
  "apitools.pending.approve": "Schváliť",
  "apitools.pending.reject": "Zamietnuť",
  "apitools.pending.noMessage": "Transakcia nenesie správu na podpis, schváliť ju nemožno. Skús výpis znova so zapnutou voľbou Zahrnúť detaily.",
  "kbcaasauth.title": "KB CAAS autorizačné workflow",
  "kbcaasauth.run": "Spustiť",
  "kbcaasauth.copyToTx": "Kopírovať do Authorize Transaction →",
  "kbcaasauth.continuation": "Pokračovanie (continuation)",
  "kbcaasauth.continue": "Pokračovať",
  "kbcaasauth.cancel": "Zrušiť session",
  "kbcaasauth.cancelConfirm": "Naozaj zrušiť?",
  "kbcaasauth.rosResult": "Výsledok ROS",
  "kbcaasauth.retriesLeft": "Zostáva pokusov",
  "kbcaasauth.expiresAt": "Vyprší",
  "kbcaasauth.recoveryHint": "Náprava",
  "kbcaasauth.canRetry": "Možno opakovať",
  "kbcaasauth.wf.activate": "Activate by KBK",
  "kbcaasauth.wf.login": "Login",
  "kbcaasauth.wf.ros": "Register ROS",
  "kbcaasauth.wf.authorize": "Authorize Transaction",
  "kbcaasauth.wf.sessions": "Sessions",
  "kbcaasauth.f.kbkToken": "KBK Token",
  "kbcaasauth.f.pinType": "Typ PINu",
  "kbcaasauth.f.language": "Jazyk",
  "kbcaasauth.f.note": "Poznámka (voliteľné)",
  "kbcaasauth.f.authSubject": "Auth Subject (KBID owner ident)",
  "kbcaasauth.f.msgToAuthData": "Dáta na podpis — msgToAuth.data (JSON)",
  "kbcaasauth.f.scoringData": "Scoring data (JSON, voliteľné)",
  "kbcaasauth.f.paatToken": "PAAT Token",
  "kbcaasauth.f.requestUri": "request_uri (z Register ROS)",
  "kbcaasauth.f.kbSessionId": "X-KB-Session-Id (z Register ROS)",
  "kbcaasauth.f.sessionId": "Session ID",
  "kbcaasauth.f.otp": "OTP",
  "kbcaasauth.f.oidcUrl": "OIDC result URL",
  "kbcaasauth.sessions.load": "Načítať sessions",
  "kbcaasauth.sessions.sessionId": "Session ID",
  "kbcaasauth.sessions.workflow": "Workflow",
  "kbcaasauth.sessions.status": "Stav",
  "kbcaasauth.sessions.template": "Šablóna",
  "kbcaasauth.sessions.lastStep": "Posledný krok",
  "kbcaasauth.sessions.use": "Použiť",
  "kbcaasauth.sessions.empty": "Žiadne sessions",
  "echtools.nav": "eChannels Tools",
  "echtools.title": "eChannels Tools",
  "echtools.subtitle": "CSOB eChannels API konzola (21 operácií + OAuth2)",
  "echtools.noConnector": "eChannels konektor nie je v tomto builde dostupný.",
  "echtools.baseUrl": "Base URL",
  "echtools.execute": "Spustiť operáciu",
  "echtools.genUuid": "Generovať UUID",
  "echtools.copy": "Kopírovať",
  "echtools.selectTransaction": "-- Vyberte transakciu --",
  "echtools.cacheToken": "Token z cache",
  "echtools.err.noCacheToken": "Najprv načítajte transakcie (Zoznam autorizácií) — chýba token z cache.",
  "echtools.signature": "Podpis",
  "echtools.oauth.title": "OAuth2 token",
  "echtools.oauth.subject": "Subject (ID používateľa)",
  "echtools.oauth.subject.hint": "Posiela sa pri každej operácii",
  "echtools.oauth.clientId": "Client ID",
  "echtools.oauth.scope": "Scope",
  "echtools.oauth.scope.hint": "Aktivácia / Podpis",
  "echtools.oauth.scope.activation": "Aktivácia",
  "echtools.oauth.scope.signing": "Podpis",
  "echtools.oauth.override": "Access token override",
  "echtools.oauth.override.hint": "Nastavené → obíde OAuth2 (Bearer)",
  "echtools.oauth.getToken": "Získať access token",
  "echtools.oauth.expiresIn": "Vyprší za",
  "echtools.group.activation": "Aktivácia",
  "echtools.group.authorization": "Autorizácia",
  "echtools.group.otp": "OTP",
  "echtools.group.profile": "Profil / IPPID",
  "echtools.group.deviceReplacement": "Výmena zariadenia",
  "echtools.group.transaction": "Transakcia",
  "echtools.group.displayPin": "Display PIN",
  "echtools.op.initActivation": "Init aktivácie",
  "echtools.op.getInstanceInfo": "Info o inštancii",
  "echtools.op.finishActivation": "Dokončiť aktiváciu",
  "echtools.op.processActivation": "Spracovať aktiváciu",
  "echtools.op.createAuthRequest": "Vytvoriť autorizáciu",
  "echtools.op.confirmAuthRequest": "Potvrdiť autorizáciu",
  "echtools.op.getAuthDetail": "Detail autorizácie",
  "echtools.op.getAuthDetailPost": "Detail autorizácie (POST)",
  "echtools.op.getAuthList": "Zoznam autorizácií",
  "echtools.op.receiveElbCache": "Receive ELB Cache",
  "echtools.op.receiveAuthStatus": "Receive Auth Status",
  "echtools.op.rejectAuthRequest": "Zamietnuť autorizáciu",
  "echtools.op.setOfflineStatus": "Nastaviť offline stav",
  "echtools.op.verifyOtp": "Overiť OTP",
  "echtools.op.validateOtp": "Validovať OTP",
  "echtools.op.addIppid": "Pridať IPPID",
  "echtools.op.removeIppid": "Odobrať IPPID",
  "echtools.op.createReplacement": "Vytvoriť výmenu zariadenia",
  "echtools.op.processReplacement": "Spracovať výmenu zariadenia",
  "echtools.op.confirmTransaction": "Potvrdiť transakciu",
  "echtools.op.displayPinToken": "Display PIN Token",
  "echtools.f.activationOtp": "Aktivačné OTP",
  "echtools.f.activationGuid": "Aktivačný GUID",
  "echtools.f.instanceId": "Instance ID",
  "echtools.f.reason": "Dôvod",
  "echtools.f.tokenId": "Token",
  "echtools.f.mobileSDKData": "Mobile SDK Data",
  "echtools.f.isMigration": "Migrácia",
  "echtools.f.message": "Správa (base64)",
  "echtools.f.applicationId": "Application ID",
  "echtools.f.pushIdentifier": "Push Identifier",
  "echtools.f.processGuid": "Process GUID",
  "echtools.f.signId": "Sign ID",
  "echtools.f.transactionId": "Transaction ID",
  "echtools.f.requestTypeId": "Request Type ID",
  "echtools.f.device": "Zariadenie",
  "echtools.f.secureChannelMessageSignature": "Secure Channel Message Signature",
  "echtools.f.guid": "GUID",
  "echtools.f.pinType": "Typ PINu",
  "echtools.f.usedDeviceAuthType": "Used Device Auth Type",
  "echtools.f.deviceType": "Device Type",
  "echtools.f.ippids": "IPPID (oddelené čiarkou)",
  "echtools.f.deviceId": "Device ID",
  "echtools.f.otp": "OTP",
  "echtools.f.password": "Heslo",
  "echtools.f.requestStatusId": "Request Status ID",
  "echtools.f.errorCode": "Kód chyby",
  "echtools.f.newIppidIdToken": "New IPPID ID Token",
  "echtools.f.mobileSdkData": "Mobile SDK Data",
  "echtools.f.request": "Request (šifrovaný)",
  "echtools.f.identitiesToRemove": "Identity na odobratie (čiarkou)",
  "echtools.f.operationId": "Operation ID",
  "echtools.f.signature": "Podpis",
  "echtools.f.additionalData": "Additional Data",
  "echtools.cache.title": "Cache transakcií",
  "echtools.cache.allStatuses": "Všetky stavy",
  "echtools.cache.allTypes": "Všetky typy",
  "echtools.cache.type": "Typ",
  "echtools.cache.status": "Stav",
  "echtools.cache.expiration": "Expirácia",
  "echtools.cache.detail": "Detail",
  "echtools.cache.loaded": "Načítané",
  "echtools.cache.notLoaded": "Nenačítané",
  "echtools.cache.fetchDetail": "Načítať detail",
  "echtools.cache.confirmValid": "Potvrdiť (valid)",
  "echtools.cache.confirmInvalid": "Potvrdiť (invalid)",
  "echtools.cache.reject": "Zamietnuť",
  "asymtools.nav": "Asym requesty",
  "asymtools.title": "Asym requesty",
  "asymtools.subtitle": "Vydá podpísaný request, podpis správy alebo oboje naraz — odoslanie na auth server je na vás",
  "asymtools.token": "Token",
  "asymtools.tokenPlaceholder": "Vyberte alebo zadajte Token ID",
  "asymtools.operation": "Operácia",
  "asymtools.operationId": "ID operácie",
  "asymtools.operationIdHint": "Identifikátor z predchádzajúceho kroku výmeny zariadenia.",
  "asymtools.build": "Vygenerovať request",
  "asymtools.running": "Generujem…",
  "asymtools.notSentHint": "Server request iba zostavil. Odoslať na auth server si ho musíte sami.",
  "asymtools.copy": "Kopírovať",
  "asymtools.copied": "Skopírované",
  "asymtools.group.tx": "Transakcie",
  "asymtools.group.token": "Token a inštancia",
  "asymtools.group.dr": "Výmena zariadenia",
  "asymtools.group.auth": "Prihlásenie",
  "asymtools.op.getPendingTransactions": "Čakajúce transakcie",
  "asymtools.op.getInstanceInfo": "Informácie o inštancii",
  "asymtools.op.approveTransaction": "Schválenie transakcie",
  "asymtools.op.rejectTransaction": "Zamietnutie transakcie",
  "asymtools.op.deactivate": "Deaktivácia inštancie",
  "asymtools.op.createDeviceReplacement": "Založenie výmeny zariadenia",
  "asymtools.op.processDeviceReplacement": "Dokončenie výmeny zariadenia",
  "asymtools.op.login": "Prihlásenie",
  "asymtools.sign.message": "Správa od auth servera",
  "asymtools.sign.messageHint": "Base64 zašifrovaná správa — secureChannelMessage transakcie alebo challenge z prihlásenia.",
  "asymtools.sign.scoringFlags": "Scoring flags",
  "asymtools.sign.submit": "Podpísať",
  "asymtools.sign.decrypt": "Dešifrovať",
  "asymtools.tool": "Nástroj",
  "asymtools.tool.request": "Obálka requestu",
  "asymtools.tool.request.hint": "Vygeneruje podpísanú obálku, ktorú by token poslal auth serveru. Pri schválení transakcie a druhom kroku prihlásenia obálka sama nestačí — použite Obálku s podpisom.",
  "asymtools.tool.approve": "Obálka s podpisom",
  "asymtools.tool.approve.hint": "Náprotivok metódy SDK createApproveTransactionRequest: obálka, podpis aj additionalData jedným volaním. Použite na schválenie transakcie, druhý krok prihlásenia aj autorizáciu platby.",
  "asymtools.tool.approve.submit": "Vygenerovať a podpísať",
  "asymtools.tool.signature": "Iba podpis",
  "asymtools.tool.signature.hint": "Podpíše správu od auth servera a vráti podpis so zodpovedajúcim additionalData. Obálku si vezmite z nástroja Obálka requestu.",
  "asymtools.tool.decrypt": "Dešifrovanie",
  "asymtools.tool.decrypt.hint": "Ukáže obsah správy od auth servera, teda čo sa vlastne podpisuje.",
  "asymtools.sign.scoringFlagsHint": "Bit 0 = rooted, bit 1 = biometria. Má prednosť pred typom overenia.",
  "asymtools.sign.recognitionType": "Typ overenia",
  "asymtools.sign.recognitionTypeHint": "Použije sa, len keď scoring flags necháte prázdne. Pozor: SDK čísluje inak (None 0 / Password 1 / Biometric 2).",
  "asymtools.sign.recognitionType.unset": "Neuvádzať",
  "asymtools.sign.recognitionType.password": "0 — heslo",
  "asymtools.sign.recognitionType.biometrics": "1 — biometria",
  "asymtools.sign.password": "Heslo",
  "asymtools.sign.passwordValid": "Platné",
  "asymtools.sign.passwordInvalid": "Zámerne chybné",
  "asymtools.sign.userPassword": "Heslo (override)",
  "asymtools.sign.userPasswordHint": "Nepovinné. Prázdne = použije sa heslo uložené pri tokene. Pri zámerne chybnom hesle sa ignoruje, preto sa pole neponúka.",
  "asymtools.warning": "Upozornenie",
  "asymtools.nextCall": "Kam to patrí na drôte",
  "asymtools.nextCall.query": "Parametre dopytu",
  "asymtools.nextCall.body": "Telo požiadavky",
  "asymtools.nextCall.alternatives": "Tie isté hodnoty patria aj sem",
  "soaptools.nav": "SOAP Tools",
  "soaptools.title": "SOAP Tools",
  "soaptools.subtitle": "eCobra SOAP operácie s náhľadom XML požiadavky",
  "soaptools.endpoint": "Endpoint",
  "soaptools.noConnector": "SOAP konektor nie je v tomto builde dostupný.",
  "soaptools.health.checking": "Kontrolujem…",
  "soaptools.health.healthy": "Pripojené",
  "soaptools.health.unhealthy": "Nedostupné",
  "soaptools.health.refresh": "Obnoviť stav",
  "soaptools.execute": "Spustiť SOAP požiadavku",
  "soaptools.executeHint": "Vyplňte parametre a spustite operáciu.",
  "soaptools.requestXml": "XML požiadavky",
  "soaptools.response": "Odpoveď",
  "soaptools.opt.yes": "Áno",
  "soaptools.opt.no": "Nie",
  "soaptools.group.otp": "Správa OTP",
  "soaptools.group.device": "Správa zariadení",
  "soaptools.group.sms": "Správa SMS",
  "soaptools.group.authorization": "Autorizácia",
  "soaptools.op.generateOtp": "Generovať OTP",
  "soaptools.op.getUserOtp": "Získať OTP používateľa",
  "soaptools.op.getInstanceInfo": "Info o inštancii",
  "soaptools.op.getUserDeviceList": "Zoznam zariadení používateľa",
  "soaptools.op.getUserSmsPhoneNumber": "Získať telefón pre SMS",
  "soaptools.op.setUserSmsPhoneNumber": "Nastaviť telefón pre SMS",
  "soaptools.op.decryptSecureMessages": "Dešifrovať Secure Messages",
  "soaptools.op.authorizationChallenge": "Autorizácia — Challenge",
  "soaptools.op.authorizationProcess": "Autorizácia — Process",
  "soaptools.f.identity": "Identita",
  "soaptools.f.deviceOSType": "OS zariadenia",
  "soaptools.f.reason": "Dôvod",
  "soaptools.f.sendSms": "Poslať SMS",
  "soaptools.f.device": "ID zariadenia",
  "soaptools.f.deviceType": "Typ zariadenia",
  "soaptools.f.appVersionCode": "Verzia aplikácie",
  "soaptools.f.identities": "Identity (oddelené čiarkou)",
  "soaptools.f.filterStatus": "Filter stavu (voliteľné)",
  "soaptools.f.smsPhoneNumber": "Telefónne číslo",
  "soaptools.f.secureChannelMessage": "Secure Channel správa (Base64)",
  "soaptools.f.operationType": "Typ operácie",
  "soaptools.f.hash": "Hash",
  "soaptools.f.title": "Titulok",
  "soaptools.f.signedDataFields": "Signed Data polia (čiarkou)",
  "soaptools.f.signedDataLabels": "Signed Data popisy (čiarkou)",
  "soaptools.f.signId": "Sign ID",
  "soaptools.f.signature": "Podpis (MAC kód)",
  "soaptools.f.signatureType": "Typ podpisu",
  "loadtest.nav": "Loadtest generátor",
  "loadtest.title": "Load Test Generátor",
  "loadtest.subtitle": "Vygeneruje ZIP bundle (JMeter plán + identity + warmup)",
  "loadtest.section.scenario": "Scenár",
  "loadtest.section.identities": "Identity",
  "loadtest.section.load": "Záťaž a cieľ",
  "loadtest.section.warmup": "Warmup",
  "loadtest.warmup.unavailable": "V tomto builde nie je dostupný žiadny warm-up provider — vygenerovaný plán sa nespustí (warm-up vyžaduje eCobra SOAP konektor).",
  "loadtest.warmup.available": "Warm-up dostupný pre: {{types}}",
  "loadtest.section.apiKey": "API kľúč",
  "loadtest.targetSystem": "Cieľový systém",
  "loadtest.scenario": "Scenár",
  "loadtest.warmupMode": "Režim warmup",
  "loadtest.warmup.runtime": "Runtime (čerstvé OTP na iteráciu)",
  "loadtest.warmup.pregenerated": "Pre-generated (zapiecť OTP do CSV teraz)",
  "loadtest.source.list": "Zoznam (CSV)",
  "loadtest.source.pattern": "Vzor",
  "loadtest.identitiesCsv": "Identity (CSV)",
  "loadtest.identitiesCsv.hint": "Jeden riadok na identitu",
  "loadtest.usernamePrefix": "Prefix mena",
  "loadtest.startIndex": "Start index",
  "loadtest.endIndex": "End index",
  "loadtest.padWidth": "Pad width",
  "loadtest.phonePattern": "Vzor telefónu",
  "loadtest.password": "Heslo",
  "loadtest.paatProfile": "PAAT profil",
  "loadtest.threads": "Vlákna",
  "loadtest.rampUp": "Ramp-up (s)",
  "loadtest.loops": "Slučky",
  "loadtest.protocol": "Protokol",
  "loadtest.host": "Host",
  "loadtest.port": "Port",
  "loadtest.clientIdent": "Client Ident",
  "loadtest.systemId": "System ID",
  "loadtest.deviceOSType": "OS zariadenia",
  "loadtest.reason": "Dôvod",
  "loadtest.sendSms": "Poslať SMS",
  "loadtest.setPhone": "Nastaviť telefón",
  "loadtest.embedApiKey": "Vložiť API kľúč do bundlu",
  "loadtest.apiKey": "API kľúč",
  "loadtest.generate": "Generovať bundle",
  "loadtest.generated": "Bundle vygenerovaný, sťahovanie začaté (etts-loadtest.zip).",
  "paat.title": "PAAT profily",
  "paat.subtitle": "Device-info profily pre eChannels aktiváciu",
  "paat.add": "Pridať profil",
  "paat.bulkUpdate": "Hromadná úprava verzií",
  "paat.editTitle": "Upraviť PAAT profil",
  "paat.deleteTitle": "Zmazať PAAT profil",
  "paat.deleteConfirm": "Naozaj zmazať profil „{{id}}\"? Nemožno zmazať profil používaný tokenmi.",
  "paat.default": "Predvolený",
  "paat.setDefault": "Nastaviť ako predvolený",
  "paat.selectPlatform": "-- Vyberte platformu --",
  "paat.fillRequired": "Vyplňte všetky povinné polia",
  "paat.versionCode": "Version code",
  "paat.apiLevel": "API level",
  "paat.language": "Jazyk",
  "paat.deviceModel": "Model zariadenia",
  "paat.deviceName": "Názov zariadenia",
  "paat.deviceManufacturer": "Výrobca",
  "paat.bulkHint": "Aktualizuje verzie u všetkých profilov danej platformy. Aspoň jedna verzia je povinná.",
  "paat.bulkNeedVersion": "Zadajte aspoň jednu verziu",
  "paat.bulkApply": "Aplikovať",
  "paat.idPattern": "ID smie obsahovať len písmená, číslice, pomlčku a podčiarknutie",
  "paat.idHint": "Písmená, číslice, pomlčka, podčiarknutie",
  "paat.bulkConfirm": "Potvrdiť a aktualizovať",
  "paat.bulkConfirmSummary": "Aktualizovať všetky profily platformy {{platform}}?",
  "paat.col.id": "ID",
  "paat.col.name": "Názov",
  "paat.col.platform": "Platforma",
  "paat.col.appVersion": "App verzia",
  "paat.col.sdkVersion": "SDK verzia",
  "paat.col.usage": "Použitie",
  "paat.col.device": "Zariadenie",
  "paat.col.versionCode": "Version code",
  "paat.col.apiLevel": "API level",
  "paat.col.default": "Predvolený",
  "tokens.col.tags": "Tagy",
  "tokens.col.paat": "PAAT profil",
  "tokens.col.actions": "Akcie",
  "tokens.filter.all": "Všetko",
  "tokens.filter.clear": "Vymazať filtre",
  "tokens.filter.usernamePlaceholder": "Hľadať username…",
  "tokens.filter.tokenIdPlaceholder": "Hľadať Token ID…",
  "tokens.filter.tagPlaceholder": "Hľadať tag…",
  "tokens.results.count": "Nájdených {{count}} tokenov",
  "tokens.results.empty": "Žiadne tokeny nenájdené.",
  "tokens.action.detail": "Otvoriť detail",
  "tokens.action.copyId": "Kopírovať Token ID",
  "tokens.action.sync": "Synchronizovať stav",
  "tokens.action.tags": "Upraviť tagy",
  "tokens.action.expiration": "Expirácia",
  "tokens.action.paat": "Zmeniť PAAT profil",
  "tokens.action.blocked.deleted": "Nedá sa pri zmazanom tokene",
  "tokens.action.blocked.notActivated": "Token zatiaľ nie je aktivovaný",
  "tokens.action.blocked.notActive": "Len pri aktívnom tokene",
  "tokens.action.changePassword": "Zmeniť heslo",
  "tokens.action.generateOtp": "Generovať OTP",
  "tokens.pw.required": "Heslo je povinné.",
  "tokens.pw.old": "Staré heslo",
  "tokens.pw.new": "Nové heslo",
  "tokens.pw.label": "Heslo",
  "tokens.otp.expiresAt": "Vyprší",
  "tokens.field.password": "Heslo (PIN)",
  "tokens.field.pushIdentifier": "Push Identifier",
  "tokens.field.deviceFingerprint": "Device Fingerprint",
  "tokens.secrets": "Token Secrets (SDK)",
  "tokens.secret.encryptionSalt": "Encryption salt",
  "tokens.secret.passwordCommon": "Heslo (common)",
  "tokens.secret.secretPassword": "Heslo (secret)",
  "tokens.secret.asymTokenData": "AsymToken data",
  "common.close": "Zavrieť",
  "tokens.action.deactivate": "Deaktivovať",
  "tokens.action.waitingForAuthServer": "Čaká sa na odpoveď auth servera. Ak neodpovedá, môže to trvať až minútu.",
  "tokens.action.delete": "Zmazať",
  "tokens.deactivateConfirm": "Naozaj deaktivovať token {{tokenId}}? Zavolá sa auth server.",
  "tokens.deleteConfirm": "Naozaj natrvalo zmazať token {{tokenId}}? Akciu nemožno vrátiť.",
  "tokens.tagsLabel": "Tagy (oddelené čiarkou)",
  "tokens.expiration.clear": "Zrušiť expiráciu",
  "tokens.expiration.ttlSeconds": "TTL v sekundách (voliteľné)",
  "tokens.expiration.ttlHint": "Keď je vyplnené, má prednosť pred dátumom — expirácia = teraz + N sekúnd.",
  "tokens.paat.warning": "Zmena PAAT profilu môže zmeniť platformu tokenu (Android/iOS). Uistite sa, že to zodpovedá skutočnému zariadeniu.",
  "tokens.tab.overview": "Prehľad",
  "tokens.tab.activation": "Aktivácia",
  "tokens.tab.device": "Zariadenie a kľúče",
  "tokens.sync.changed": "Stav zosynchronizovaný: {{from}} → {{to}}",
  "tokens.sync.unchanged": "Stav sa nezmenil ({{state}}) — auth server hlási to isté čo eTTS.",
  "tokens.sync.failed": "Synchronizácia stavu zlyhala",
  "tokens.bulk.selected": "Vybraných {{tokens}} tokenov",
  "tokens.bulk.allMatchingSelected": "Vybraných všetkých {{tokens}} tokenov podľa filtra",
  "tokens.bulk.selectAllMatching": "Vybrať všetkých {{total}} podľa filtra",
  "tokens.bulk.clear": "Zrušiť výber",
  "tokens.bulk.selectPage": "Vybrať všetky na stránke",
  "tokens.bulk.selectRow": "Vybrať token {{tokenId}}",
  "tokens.bulk.scope.ids": "Vybrané tokeny: {{tokens}}",
  "tokens.bulk.scope.filter": "Všetky tokeny podľa filtra: {{tokens}}",
  "tokens.bulk.blockedHint": "Pri {{count}} vybraných tokenoch akciu stav nedovolí — server ich preskočí a uvedie v súhrne.",
  "tokens.bulk.confirmUnderstand": "Rozumiem, že akcia sa vykoná nad {{tokens}} tokenmi a nedá sa vrátiť.",
  "tokens.bulk.start": "Spustiť",
  "tokens.bulk.stop": "Zastaviť",
  "tokens.bulk.stopped": "Zastavené — spracovaných {{processed}} z {{total}}. Vykonané zmeny zostávajú.",
  "tokens.bulk.progress": "Spracované {{processed}} / {{total}}",
  "tokens.bulk.summary.succeeded": "Úspešne",
  "tokens.bulk.summary.failed": "Chyba",
  "tokens.bulk.summary.skipped": "Preskočené",
  "tokens.bulk.summary.skippedHint": "Preskočené sú tokeny, ktorým akciu nedovolil ich stav, alebo medzitým zmizli.",
  "tokens.bulk.summary.errors": "Chyby ({{count}})",
  "tokens.bulk.summary.detailsTruncated": "Výpis je skrátený, úplný zoznam je v aplikačnom logu.",
  "tokens.bulk.tagsMode": "Režim úpravy tagov",
  "tokens.bulk.tagsMode.REPLACE": "Nahradiť celý zoznam",
  "tokens.bulk.tagsMode.ADD": "Pridať k existujúcim",
  "tokens.bulk.tagsMode.REMOVE": "Odobrať z existujúcich",
  "tokens.bulk.emptyTags": "Zadajte aspoň jeden tag.",
  "tokens.bulk.expirationRequired": "Zadajte dátum alebo TTL, prípadne zaškrtnite zrušenie expirácie.",
  "tokens.bulk.ttlHint": "Vyhodnotí sa raz na začiatku behu — všetky tokeny dostanú rovnaký okamih.",
  "tokens.bulk.deleteWarning": "Tokeny sa zmažú natrvalo vrátane kľúčového materiálu. Akcia sa nedá vrátiť.",
  "tokens.bulk.deactivateWarning": "Pre každý token sa volá auth server — pri tisícoch tokenov to môže trvať minúty.",
  "tokens.bulk.bypassAuthServer": "Nevolať auth server",
  "tokens.bulk.bypassAuthServerHint": "Tokeny sa označia ako zmazané len lokálne. Rýchle a funguje aj pri nedostupnom serveri, ale stav sa s ním rozíde.",
  "docs.title": "Nápoveda",
  "docs.subtitle": "Dokumentácia a návody k eTTS",
  "docs.search.placeholder": "Hľadať v nápovede…",
  "docs.search.noResults": "Nič nenájdené",
  "docs.nav.toggle": "Obsah / navigácia",
  "docs.toc.title": "Na tejto stránke",
  "docs.notFound": "Stránka nenájdená.",
  "docs.banner.notTranslated": "Táto stránka zatiaľ nebola preložená — zobrazuje sa česká verzia.",
  "docs.switchToCzech": "Prepnúť do češtiny",
  "docs.locked.title": "Funkcia nie je vo vašej licencii aktívna.",
  "common.edit": "Upraviť",
  "locale.label": "Jazyk",
  "locale.title": "Jazyk rozhrania",
  "locale.subtitle": "Voľba sa uloží k vášmu účtu a použije sa aj pre texty zo servera.",
  "locale.cs": "Čeština",
  "locale.sk": "Slovenčina",
  "locale.en": "English",
  "locale.cs.short": "CS",
  "locale.sk.short": "SK",
  "locale.en.short": "EN",
  "locale.saveError": "Jazyk sa nepodarilo uložiť. Skúste to znova.",
  "feature.advertised.badge": "Čoskoro k dispozícii",
  "feature.locked.badge": "Uzamknuté",
  "feature.advertised.title": "Čoskoro k dispozícii",
  "feature.advertised.default": "Táto funkcia je vo vývoji a bude k dispozícii v niektorom z ďalších releasov.",
  "feature.locked.title": "Funkcia nie je vo vašej licencii",
  "feature.locked.detail": "Táto funkcia nie je vo vašej licenčnej úrovni aktivovaná. Kontaktujte správcu licencií alebo upgradujte, aby ste ju odomkli.",
  "feature.plannedFor": "Plánované pre verziu {{version}}",
  "feature.viewLicense": "Zobraziť licenciu",
  "feature.id": "Identifikátor funkcie",
  "feature.hidden.title": "Stránka nie je dostupná",
  "feature.hidden.detail": "Táto časť administrácie nie je v tejto inštalácii k dispozícii.",
  "feature.backHome": "Späť na prehľad",
  "general.version": "Verzia aplikácie",
  "settings.notifications": "Oznámenia",
  "notifications.markAllRead": "Označiť všetko ako prečítané",
  "notifications.markRead": "Označiť ako prečítané",
  "notifications.viewAll": "Zobraziť všetky oznámenia",
  "notifications.unread": "Neprečítané",
  "notifications.unreadOnly": "Len neprečítané",
  "notifications.lastSeen": "naposledy",
  "notifications.severity.INFO": "Informácia",
  "notifications.severity.WARNING": "Varovanie",
  "notifications.severity.ERROR": "Chyba",
  "notifications.category.APPLICATION_ERROR": "Chyby aplikácie",
  "notifications.category.APPLICATION_ERROR.desc": "Neočakávané zlyhania — výnimky, nedostupná infraštruktúra, chyby plánovača. Zamietnutia zo strany auth servera sem nepatria: to je legitímny výsledok testu.",
  "notifications.category.MAINTENANCE": "Údržba",
  "notifications.category.MAINTENANCE.desc": "Dokončený úklid, záloha databázy, deaktivácia expirovaných tokenov.",
  "notifications.category.SECURITY": "Bezpečnosť",
  "notifications.category.SECURITY.desc": "Zámok účtu, neúspešné prihlásenia, zmena rolí, nedostupný adresár.",
  "notifications.category.EXPIRY": "Expirácia",
  "notifications.category.EXPIRY.desc": "Blížiaci sa koniec platnosti licencie, TLS certifikátu a tokenov s TTL.",
  "notifications.type.APPLICATION_ERROR_LOGGED.title": "Chyba aplikácie v {{logger}}",
  "notifications.type.APPLICATION_ERROR_LOGGED.message": "{{detail}}",
  "notifications.type.MAINTENANCE_AUTO_CLEANUP_COMPLETED.title": "Automatický úklid dokončený",
  "notifications.type.MAINTENANCE_AUTO_CLEANUP_COMPLETED.message": "Zmazaných {{httpLogs}} komunikačných logov, {{transactionLogs}} transakčných logov a {{activationEvents}} aktivačných udalostí ({{durationMs}} ms).",
  "notifications.type.MAINTENANCE_CLEANUP_COMPLETED.title": "Úklid dokončený",
  "notifications.type.MAINTENANCE_CLEANUP_COMPLETED.message": "Zmazaných {{deleted}} záznamov.",
  "notifications.type.MAINTENANCE_BACKUP_COMPLETED.title": "Záloha databázy dokončená",
  "notifications.type.MAINTENANCE_BACKUP_COMPLETED.message": "{{filename}} ({{size}}), {{durationMs}} ms.",
  "notifications.type.MAINTENANCE_TOKENS_EXPIRED.title": "Expirované tokeny deaktivované",
  "notifications.type.MAINTENANCE_TOKENS_EXPIRED.message": "Deaktivovaných {{count}} tokenov ({{durationMs}} ms).",
  "notifications.type.SECURITY_ACCOUNT_LOCKED.title": "Účet {{username}} bol uzamknutý",
  "notifications.type.SECURITY_ACCOUNT_LOCKED.message": "Uzamknutý po opakovaných neúspešných prihlásaniach.",
  "notifications.type.SECURITY_LOGIN_FAILED.title": "Neúspešné prihlásenie: {{username}}",
  "notifications.type.SECURITY_LOGIN_FAILED.message": "",
  "notifications.type.SECURITY_ROLES_CHANGED.title": "Zmena rolí používateľa {{username}}",
  "notifications.type.SECURITY_ROLES_CHANGED.message": "Nové role: {{roles}} (zmenil {{actor}}).",
  "notifications.type.SECURITY_DIRECTORY_DOWN.title": "Adresárová služba nedostupná",
  "notifications.type.SECURITY_DIRECTORY_DOWN.message": "Prihlásenie proti adresáru neprešlo — overte konektivitu.",
  "notifications.type.EXPIRY_LICENSE.title": "Licencii vyprší platnosť za {{days}} dní",
  "notifications.type.EXPIRY_LICENSE.message": "Platnosť do {{validTo}}.",
  "notifications.type.EXPIRY_TLS_CERTIFICATE.title": "TLS certifikátu vyprší platnosť za {{days}} dní",
  "notifications.type.EXPIRY_TLS_CERTIFICATE.message": "Platnosť do {{notAfter}}.",
  "notifications.type.EXPIRY_TOKENS.title": "{{count}} tokenom vyprší platnosť do {{days}} dní",
  "notifications.type.EXPIRY_TOKENS.message": "",
  "notificationSettings.title": "Oznámenia",
  "notificationSettings.subtitle": "Čo kanál eskaluje, ako dlho sa oznámenia držia a čo bolo doručené.",
  "notificationSettings.categories": "Kategórie",
  "notificationSettings.categoriesHint": "Vypnutá kategória sa nezakladá vôbec. Minimálna závažnosť odfiltruje menej dôležité udalosti v rámci kategórie.",
  "notificationSettings.minSeverity": "Minimálna závažnosť",
  "notificationSettings.retentionDays": "Retencia (dni)",
  "notificationSettings.retentionHint": "Staršie oznámenia sa mažú pri hodinovom úklide.",
  "notificationSettings.dedupWindow": "Okno zlučovania (minúty)",
  "notificationSettings.dedupHint": "Tá istá udalosť v okne len zvýši počítadlo namiesto nového riadku.",
  "notificationSettings.reset": "Vrátiť predvolené",
  "common.saved": "Uložené",
  "notifications.unreadCount": "Oznámenia — {{count}} neprečítaných",
  "notifications.category.TEST": "Testovacie",
  "notifications.category.TEST.desc": "Ručne vyvolané oznámenia na overenie, že kanál a zvonček fungujú.",
  "notifications.type.TEST_NOTIFICATION.title": "Testovacie oznámenie ({{severity}})",
  "notifications.type.TEST_NOTIFICATION.message": "Vyvolané ručne z Nastavenia → Oznámenia. Slúži len na overenie kanála.",
  "notificationSettings.testTitle": "Overenie kanála",
  "notificationSettings.testHint": "Vytvorí testovacie oznámenie, na ktorom si skontrolujete zvonček, farby závažností aj doručenie — bez čakania na skutočnú udalosť.",
  "notificationSettings.createTest": "Vytvoriť testovacie oznámenie",
  "notificationSettings.testCreated": "Vytvorené — pozrite sa na zvonček",
  "versionNotice.title": "Aplikácia bola aktualizovaná na {{version}}",
  "versionNotice.subtitle": "Naposledy ste pracovali s verziou {{previous}}. Tu je, čo je nové.",
  "versionNotice.viewAll": "Zobraziť všetky zmeny",
  "versionNotice.dismiss": "Rozumiem",
  "versionNotice.noChangelog": "K tejto verzii zatiaľ nie je záznam v prehľade zmien. Celý prehľad nájdete v pomocníkovi.",
  "notifications.type.APP_VERSION_UPDATED.title": "Aplikácia aktualizovaná na {{version}}",
  "notifications.type.APP_VERSION_UPDATED.message": "Predchádzajúca verzia: {{previousVersion}}. Prehľad zmien nájdete v pomocníkovi.",
  "scenarios.nav": "Scenáre",
  "scenarios.title": "Generátor scenárov",
  "scenarios.subtitle": "Deklaratívne scenáre — spusti ich živo v eTTS, alebo vyexportuj pre JMeter, SoapUI, Postman či k6.",
  "scenarios.catalog": "Katalóg",
  "scenarios.pickOne": "Vyber scenár zo zoznamu vľavo.",
  "scenarios.steps": "{{count}} krokov",
  "scenarios.system": "Výstupný systém",
  "scenarios.mode": "Režim",
  "scenarios.export": "Stiahnuť artefakty",
  "scenarios.exported": "Artefakty stiahnuté.",
  "scenarios.run": "Spustiť v eTTS",
  "scenarios.notLoadSafe": "len funkčný",
  "scenarios.documentProblems": "Niektoré dokumenty sa nepodarilo prečítať:",
  "scenarios.keyTtl": "Platnosť kľúča",
  "scenarios.issueKey": "Vystaviť API kľúč",
  "scenarios.keyIssued": "Kľúč vystavený s oprávneniami {{scopes}}, platí do {{expires}}. Zobrazuje sa len teraz.",
  "scenarios.keyUnresolved": "Pri krokoch {{steps}} sa oprávnenia nepodarilo určiť — kľúč na ne nemusí stačiť.",
  "perfMode.title": "Režim Performance",
  "perfMode.subtitle": "Dočasne obmedzí zápis komunikačných logov, aby záťažový test nezaplnil databázu.",
  "perfMode.activeTitle": "Režim Performance beží",
  "perfMode.activeDetail": "Komunikačné logy sú obmedzené na úroveň {{level}}.",
  "perfMode.levelLabel": "Rozsah logovania",
  "perfMode.durationLabel": "Na ako dlho",
  "perfMode.minutes": "{{count}} min",
  "perfMode.start": "Zapnúť režim",
  "perfMode.stop": "Vypnúť režim",
  "perfMode.remaining": "Zostáva",
  "perfMode.startedBy": "Zapol",
  "perfMode.suppressed": "Potlačených oznámení",
  "perfMode.goToStats": "Štatistiky servera",
  "perfMode.goToStatsAfterStart": "Po zapnutí prejsť na štatistiky servera",
  "perfMode.autoExpiryHint": "Režim vždy skončí sám. Najdlhšie môže bežať 8 hodín.",
  "perfMode.queueHint": "Riadky zapísané pred zapnutím sa ešte chvíľu doplnia z fronty.",
  "perfMode.level.FULL": "Plné logovanie",
  "perfMode.level.NO_BODIES": "Bez tiel správ",
  "perfMode.level.ERRORS_ONLY": "Len chyby",
  "perfMode.level.OFF": "Vypnuté",
  "perfMode.levelHint.FULL": "Zapisuje sa všetko vrátane tiel správ.",
  "perfMode.levelHint.NO_BODIES": "Riadok zostane, zmiznú len telá a hlavičky — tá objemná časť.",
  "perfMode.levelHint.ERRORS_ONLY": "Odporúčané. Uložia sa len neúspešné volania, zato celé.",
  "perfMode.levelHint.OFF": "Nezapisuje sa nič. Po zlyhanom teste nezostane žiadna stopa.",
  "perfMode.logsBanner": "Režim Performance beží — komunikačné logy sa teraz zapisujú obmedzene ({{level}}).",
  "perfMode.statsBanner": "Režim Performance beží. Zostáva {{remaining}}.",
  "perfMode.faster": "Obnovovať po 2 s",
  "notifications.type.MAINTENANCE_PERFORMANCE_MODE_STARTED.title": "Zapnutý režim Performance",
  "notifications.type.MAINTENANCE_PERFORMANCE_MODE_STARTED.message": "Komunikačné logy sú obmedzené ({{level}}) na {{minutes}} min. Zapol: {{actor}}.",
  "notifications.type.MAINTENANCE_PERFORMANCE_MODE_ENDED.title": "Režim Performance skončil",
  "notifications.type.MAINTENANCE_PERFORMANCE_MODE_ENDED.message": "Komunikačné logy sa zase zapisujú v plnom rozsahu. Bežal {{minutes}} min, potlačených {{suppressed}} oznámení.",
  "perfMode.sinceHint": "Beží od {{since}} — staršie riadky vznikli ešte pred zapnutím.",
  "perfMode.startedAt": "Beží od",
  "perfMode.tooltipActive": "Komunikačné logy: {{level}}. Beží od {{since}}."
}
